import { type Signal } from '@preact/signals'

import { handleAcceptCollaboratorInvitation } from 'pages/home/state'
import { removePropertyFromStoredObject } from 'utils'
import { LocalStorageKeys } from 'types'

import { PendingInvitationCard } from './PendingInvitationCard'
import { PendingInvitationsCard } from './PendingInvitationsCard'

const PendingCollaborationsContainer = ({
	pendingInvitations
}: {
	pendingInvitations: Signal<string[] | null>
}) => {
	/**
	 * Accepts the invitation for a given project and removes it from the state.
	 */
	const handleAcceptInvitation = async (projectId: string) => {
		await handleAcceptCollaboratorInvitation(projectId)

		const updatedProjects = pendingInvitations.value!.filter(
			id => id !== projectId
		)

		pendingInvitations.value =
			updatedProjects.length === 0 ? null : updatedProjects
	}

	/**
	 * Rejects the invitation by removing it from local storage and updating the state.
	 */
	const handleRejectInvitation = (projectId: string) => {
		removePropertyFromStoredObject(
			LocalStorageKeys.CollaboratorInvitationProjects,
			projectId
		)

		const updatedProjects = pendingInvitations.value!.filter(
			id => id !== projectId
		)

		pendingInvitations.value =
			updatedProjects.length === 0 ? null : updatedProjects
	}

	// If there is only one pending invitation, display the card with its name
	if (pendingInvitations.value!.length === 1) {
		return (
			<PendingInvitationCard
				handleAcceptInvitation={handleAcceptInvitation}
				handleRejectInvitation={handleRejectInvitation}
				pendingInvitation={pendingInvitations.value![0]!}
			/>
		)
	}

	// If there are multiple pending invitations, display the card with a list of them
	return (
		<PendingInvitationsCard
			handleAcceptInvitation={handleAcceptInvitation}
			handleRejectInvitation={handleRejectInvitation}
			pendingInvitations={pendingInvitations.value!}
		/>
	)
}

export { PendingCollaborationsContainer }
